__webpack_require__.p = "/2023_2024/mlab2_brandw_t4/";